import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyGlobal, MyAlert } from '../GlobalContext';

export class PrintSettings extends Component {
    static displayName = PrintSettings.name;

    constructor(props) {
        super(props);
        this.history = props.history;

        this.state = {
            loading: false,
            alertMessageLP: "",
            alertMessageA4P: "",
            selectedLPClientMachine: "",
            selectedLabelPrinter: "",
            selectedLabelPrinterId: 0, 
            labelPrinterBarcodeData: "",
            selectedA4PClientMachine: "",
            selectedA4Printer: "",
            selectedA4PrinterId: 0,
            a4PrinterBarcodeData: "",
            isLabelPrinterOnline: false,
            isLPClientMachineOnline: false,
            isA4PrinterOnline: false,
            isA4PClientMachineOnline: false
        }

    }
    componentDidMount() {
        if (MyGlobal.print_settings) {
            var globalPrintSettings = JSON.parse(MyGlobal.print_settings);
            if (globalPrintSettings) {
                this.setState({
                    selectedLPClientMachine: globalPrintSettings.selectedLPClientMachine,
                    selectedLabelPrinter: globalPrintSettings.selectedLabelPrinter,
                    selectedA4PClientMachine: globalPrintSettings.selectedA4PClientMachine,
                    selectedA4Printer: globalPrintSettings.selectedA4Printer,
                });
                this.loadSavedPrinters(globalPrintSettings.selectedLabelPrinter, globalPrintSettings.selectedLPClientMachine, true);
                this.loadSavedPrinters(globalPrintSettings.selectedA4Printer, globalPrintSettings.selectedA4PClientMachine, false);
            }
        }
        this.refs.barcodeDataInput.focus();
    }



    clearAll() {
        this.setState({
            alertMessageLP: "",
            alertMessageA4P: "",
            selectedLPClientMachine: "",
            selectedLabelPrinter: "",
            labelPrinterBarcodeData: "",
            selectedA4PClientMachine: "",
            selectedA4Printer: "",
            a4PrinterBarcodeData: "",
            selectedA4PrinterId: 0,
            selectedLabelPrinterId: 0,
        });

        MyGlobal.print_settings = JSON.stringify({
            selectedLPClientMachine: "",
            selectedLabelPrinter: "",
            selectedA4PClientMachine: "",
            selectedA4Printer: ""
        });
    }

    loadSavedPrinters(printerName, machineName, isLabelPrinter) {

        if (printerName && machineName) {
            fetch(`api/PrintService/GetPrinterMachineDetails?printerName=${printerName}&machineName=${machineName}`)
                .then(async response => {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    const data = apiResponse.printerMachineDetails;

                    // check for error response
                    if (!response.ok) {
                        const errorText = await response.text();
                        isLabelPrinter === true ? this.setState({ alertMessageLP: errorText, isLabelPrinterOnline: false, isLPClientMachineOnline: false, selectedLabelPrinterId: 0 }):
                            this.setState({ alertMessageA4P: errorText, isA4PrinterOnline: false, isA4PClientMachineOnline: false, selectedA4PrinterId: 0  });
                    }
                    else {

                        if (apiResponse.success) {
                            isLabelPrinter === true ? this.setState({ isLabelPrinterOnline: data.isPrinterOnline, isLPClientMachineOnline: data.clientMachineOnline, selectedLabelPrinterId: data.printerId }) :
                                this.setState({ isA4PrinterOnline: data.isPrinterOnline, isA4PClientMachineOnline: data.clientMachineOnline, selectedA4PrinterId: data.printerId });

                            if (!data.clientMachineOnline) {
                                isLabelPrinter === true ? this.setState({ alertMessageLP: "Make sure Client machine and Printer is online " }) :
                                    this.setState({ alertMessageA4P: "Make sure Client machine and Printer is online " });
                            }
                        }
                        else {
                            isLabelPrinter === true ? this.setState({ alertMessageLP: apiResponse.errorMessage, isLabelPrinterOnline: false, isLPClientMachineOnline: false, selectedLabelPrinterId: 0  }) :
                                this.setState({ alertMessageA4P: apiResponse.errorMessage, isA4PrinterOnline: false, isA4PClientMachineOnline: false, selectedA4PrinterId: 0  });
                        }
                    }

                })
                .catch(error => {
                    isLabelPrinter === true ? this.setState({ alertMessageLP: error, isLabelPrinterOnline: false, isLPClientMachineOnline: false, selectedLabelPrinterId: 0 }) :
                        this.setState({ alertMessageA4P: error, isA4PrinterOnline: false, isA4PClientMachineOnline: false, selectedA4PrinterId : 0 });
                });
        }
    }

    saveLabelPrinter() {
        var barcodeData = this.state.labelPrinterBarcodeData.split(",");
        if (barcodeData.length >= 2) {
            var selectedClientMachine = barcodeData[0].trim();
            var selectedPrinter = barcodeData[1].trim();

            
            this.setState({
                selectedLPClientMachine: selectedClientMachine,
                selectedLabelPrinter: selectedPrinter
            });

            MyGlobal.print_settings = JSON.stringify({
                selectedLPClientMachine: selectedClientMachine,
                selectedLabelPrinter: selectedPrinter,
                selectedA4PClientMachine: this.state.selectedA4PClientMachine,
                selectedA4Printer: this.state.selectedA4Printer,
                selectedA4PrinterId: this.state.selectedA4PrinterId
            });

            this.state.loading = true;
            fetch(`api/PrintService/GetPrinterMachineDetails?printerName=${selectedPrinter}&machineName=${selectedClientMachine}`)
                .then(async response => {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    const data = apiResponse.printerMachineDetails;
                    
                    // check for error response
                    if (!response.ok) {
                        const errorText = await response.text();
                        this.setState({ alertMessageLP: errorText, isLabelPrinterOnline: false, isLPClientMachineOnline: false, selectedLabelPrinterId : 0 });
                    }
                    else {
                        if (apiResponse.success) {
                            this.setState({ isLabelPrinterOnline: data.isPrinterOnline, isLPClientMachineOnline: data.clientMachineOnline, selectedLabelPrinterId : data.printerId });

                            if (!data.clientMachineOnline) {
                                this.setState({ alertMessageLP: "Make sure Client machine and Printer is online" });
                            }
                            else {
                                this.setState({ alertMessageLP: "" });
                                MyGlobal.print_settings = JSON.stringify({
                                    selectedLPClientMachine: selectedClientMachine,
                                    selectedLabelPrinter: selectedPrinter,
                                    selectedLabelPrinterId: data.printerId,
                                    selectedA4PClientMachine: this.state.selectedA4PClientMachine,
                                    selectedA4Printer: this.state.selectedA4Printer,
                                    selectedA4PrinterId: this.state.selectedA4PrinterId
                                });
                            }
                        }
                        else {
                            this.setState({ alertMessageLP: apiResponse.errorMessage, isLabelPrinterOnline: false, isLPClientMachineOnline: false, selectedLabelPrinterId : 0 });
                        }
                    }

                })
                .catch(error => {
                    this.setState({ alertMessageLP: error, isLabelPrinterOnline: false, isLPClientMachineOnline: false, selectedLabelPrinterId: 0 });
                });



        }
    }
    saveA4Printer() {
        var barcodeData = this.state.a4PrinterBarcodeData.split(",");
        if (barcodeData.length >= 2) {
            var selectedClientMachine = barcodeData[0].trim();
            var selectedPrinter = barcodeData[1].trim();

            this.setState({
                selectedA4PClientMachine: selectedClientMachine,
                selectedA4Printer: selectedPrinter
            });

            MyGlobal.print_settings = JSON.stringify({
                selectedLPClientMachine: this.state.selectedLPClientMachine,
                selectedLabelPrinter: this.state.selectedLabelPrinter,
                selectedLabelPrinterId: this.state.selectedLabelPrinterId,
                selectedA4PClientMachine: selectedClientMachine,
                selectedA4Printer: selectedPrinter,
            });

            this.state.loading = true;
            fetch(`api/PrintService/GetPrinterMachineDetails?printerName=${selectedPrinter}&machineName=${selectedClientMachine}`)
                .then(async response => {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    const data = apiResponse.printerMachineDetails;

                    // check for error response
                    if (!response.ok) {
                        const errorText = await response.text();
                        this.setState({ alertMessageA4P: errorText, isA4PrinterOnline: false, isA4PClientMachineOnline: false, selectedA4PrinterId: 0  });
                    }
                    else {
                        if (apiResponse.success) {
                            this.setState({ isA4PrinterOnline: data.isPrinterOnline, isA4PClientMachineOnline: data.clientMachineOnline, selectedA4PrinterId: data.printerId });

                            if (!data.clientMachineOnline) {

                                this.setState({ alertMessageA4P: "Make sure Client machine and Printer is online " });
                            }
                            else {
                                this.setState({ alertMessageA4P: "" });
                                MyGlobal.print_settings = JSON.stringify({
                                    selectedLPClientMachine: this.state.selectedLPClientMachine,
                                    selectedLabelPrinter: this.state.selectedLabelPrinter,
                                    selectedLabelPrinterId: this.state.selectedLabelPrinterId,
                                    selectedA4PClientMachine: selectedClientMachine,
                                    selectedA4Printer: selectedPrinter,
                                    selectedA4PrinterId: data.printerId,
                                });
                            }
                        }
                        else {
                            this.setState({ alertMessageA4P: apiResponse.errorMessage, isA4PrinterOnline: false, isA4PClientMachineOnline: false, selectedA4PrinterId: 0 });
                        }
                    }

                })
                .catch(error => {
                    this.setState({ alertMessageA4P: error, isA4PrinterOnline: false, isA4PClientMachineOnline: false, selectedA4PrinterId:0 });
                });
        }
    }

    sendTestPrintToLabelPrinter() {
      

        this.state.loading = true;
        const rawEPLPrintRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                PrinterId: this.state.selectedLabelPrinterId,
                PrintMessage: "PDA - Test Print"
            })
        };
        fetch('api/PrintService/PrintRAWEPL', rawEPLPrintRequest)
            .then(async response => {
                this.state.loading = false;
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const apiResponse = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {

                    const errorText = await response.text();
                    this.setState({ alertMessageLP: "Test Print Failed!! " + errorText });
                }
                else {
                    if (apiResponse.success) {
                        this.setState({ alertMessageLP: "Test Print Successful!! " + apiResponse.message });
                    }
                    else {
                        this.setState({ alertMessageLP: "Test Print Failed!! " + apiResponse.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ inventories: [], alertMessage: error });
            });


        
    }

    sendTestPrintToA4Printer() {


        this.state.loading = true;
        const printRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                PrinterId: this.state.selectedA4PrinterId,
                PrintMessage: "PDA - Test Print"
            })
        };
        fetch('api/PrintService/PrintToPDF', printRequest)
            .then(async response => {
                this.state.loading = false;
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const apiResponse = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {

                    const errorText = await response.text();
                    this.setState({ alertMessageLP: "Test Print Failed!! " + errorText });
                }
                else {
                    if (apiResponse.success) {
                        this.setState({ alertMessageLP: "Test Print Successful!! " + apiResponse.message });
                    }
                    else {
                        this.setState({ alertMessageLP: "Test Print Failed!! " + apiResponse.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ inventories: [], alertMessage: error });
            });



    }
    render() {

        let alertMessageLP = this.state.alertMessageLP;
        alertMessageLP = alertMessageLP != "" ? <MyAlert variant="danger">{alertMessageLP}</MyAlert> : "";

        let alertMessageA4P = this.state.alertMessageA4P;
        alertMessageA4P = alertMessageA4P != "" ? <MyAlert variant="danger">{alertMessageA4P}</MyAlert> : "";

        return (
            <div>
                <Container>

                    <Row className="mb-3">
                        <Col>
                            <h5>Label Printer</h5>
                            {alertMessageLP}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <label>Selected Client Machine : {this.state.selectedLPClientMachine} </label> <label> Status:  {this.state.isLPClientMachineOnline ? "Online" : "Offline"}</label>
                            <br />
                            <label>Selected Printer : {this.state.selectedLabelPrinter} </label> <label> Status:  {this.state.isLabelPrinterOnline ? "Online" : "Offline"}</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <input ref="barcodeDataInput" className="form-control" placeholder="Client Machine Name , Printer Name"
                                value={this.state.labelPrinterBarcodeData}
                                onChange={(e) => {
                                    this.setState({ labelPrinterBarcodeData: e.target.value });
                                }} ></input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <button type="button" className="btn btn-info col-6" onClick={() => { this.saveLabelPrinter(); }}>Save Printer</button>
                        </Col>
                        <Col>
                            <button type="button" className="btn btn-info col-6" onClick={() => { this.sendTestPrintToLabelPrinter(); }}>Send Test Print</button>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col>
                            <h5>A4 Printer</h5>
                            {alertMessageA4P}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <label>Selected Client Machine : {this.state.selectedA4PClientMachine} </label> <label> Status:  {this.state.isA4PClientMachineOnline ? "Online" : "Offline"} </label>
                            <br />
                            <label>Selected Printer : {this.state.selectedA4Printer} </label> <label> Status:  {this.state.isA4PrinterOnline ? "Online" : "Offline"}</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <input className="form-control" placeholder="Client Machine Name , Printer Name"
                                value={this.state.a4PrinterBarcodeData}
                                onChange={(e) => {
                                    this.setState({ a4PrinterBarcodeData: e.target.value });
                                }} ></input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <button type="button" className="btn btn-info col-6" onClick={() => { this.saveA4Printer(); }}>Save Printer</button>
                        </Col>
                        <Col>
                            <button type="button" className="btn btn-info col-6" onClick={() => { this.sendTestPrintToA4Printer(); }}>Send Test Print</button>
                        </Col>
                    </Row>


                    <Row className="mb-3">
                        <Col>
                            <button type="button" className="btn btn-info col-12" onClick={() => { this.clearAll(); }}>Clear</button>
                        </Col>
                    </Row>

                </Container>
            </div>

        );
    }


}